import isBlank from '../../../Common/Utils/Blank';

const CanViewPublisher = (formData) => (
  formData && isBlank(formData.all_publishers)
);

export default CanViewPublisher;



// WEBPACK FOOTER //
// ./src/views/Components/Teams/Helpers/CanViewPublisher.tsx